import React, { memo } from 'react';
import styles from './footer.module.scss';
import Logo from '@/assets/images/logo-corp.png'

export const Footer = memo((props) => {

	return (
		<>
			<div className={styles.footer}>
				<img src={Logo} className={styles.logo} alt="AssetCommunications" />
			</div>
		</>
	);
});
